import appStoreBadge from '@/assets/marketing/images/badges/app-store-badge.svg'
import googlePlayBadge from '@/assets/marketing/images/badges/google-play-badge.svg'
import fuelAppMock from '@/assets/marketing/images/fuel-app-mock.png'
import fuelAppMockSmall from '@/assets/marketing/images/fuelapp/fuel-app-mock-small.png'
import fuelAppIcon from '@/assets/marketing/images/fuelapp/fuelapp-icon.svg'
import fuelAppWordmark from '@/assets/marketing/images/fuelapp/fuelapp-wordmark.svg'
import { trackMarketingCta } from '@/lib/analytics'
import { Reveal } from './Reveal'

export function ProductsSection() {
  return (
    <section id="products" className="mx-auto max-w-(--maxw) px-5.5 py-24">
      <Reveal>
        <span className="eyebrow">Other Cai Products</span>
        <h3 className="h3 mt-6">Driving down your cost-per-mile</h3>
        <p className="text-md text-ink-500 mt-4 max-w-[640px] leading-[1.55]">
          We make financial technology to empower the businesses that build, move, and fix the world around
          us.
        </p>

        <div className="mt-12 grid grid-cols-3 gap-4 max-md:grid-cols-1">
          {/* FuelApp — amber panel */}
          <div className="text-ink-400 relative col-span-2 flex min-h-[420px] flex-col items-start justify-start gap-2 overflow-hidden rounded-sm bg-[#FAB505] p-10 max-md:col-span-1 max-md:min-h-[360px] max-md:p-6">
            <div className="relative z-1 flex max-w-[55%] flex-1 flex-col items-start justify-between gap-4 max-md:max-w-full">
              <img src={fuelAppIcon} alt="" width={64} height={64} className="rounded-xl" />
              <div className="flex flex-col items-start gap-4">
                <img src={fuelAppWordmark} alt="FuelApp" className="h-8 w-auto" />
                <p className="text-ink max-w-[420px] text-xl leading-[1.4]">
                  Find discounts up to $1.00 per gallon at the nation&apos;s largest truck stop networks.
                </p>
                <div className="mt-2 flex gap-4">
                  <a
                    href="https://apps.apple.com/us/app/fuelapp-diesel-discounts/id6759668944"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => trackMarketingCta('products_fuelapp_app_store')}
                  >
                    <img src={appStoreBadge} alt="Download on the App Store" className="block h-10 w-auto" />
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.cloudtrucks.fuelapp&hl=en_US&pli=1"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => trackMarketingCta('products_fuelapp_google_play')}
                  >
                    <img src={googlePlayBadge} alt="Get it on Google Play" className="block h-10 w-auto" />
                  </a>
                </div>
              </div>
            </div>
            <div className="absolute top-0 right-0 bottom-0 max-md:static max-md:-mx-6 max-md:mt-6 max-md:-mb-6 max-md:self-stretch">
              <img
                src={fuelAppMockSmall}
                alt="FuelApp mobile interface"
                className="block h-full w-auto max-md:hidden"
              />
              <img
                src={fuelAppMock}
                alt="FuelApp mobile interface"
                className="hidden max-md:block max-md:h-auto max-md:w-full"
              />
            </div>
          </div>

          {/* Compliance — ink panel */}
          <div className="bg-ink-900 text-ink-400 relative col-span-1 flex min-h-[420px] flex-col items-start justify-between gap-2 overflow-hidden rounded-sm p-10 max-md:col-span-1 max-md:min-h-[360px] max-md:p-6">
            <div
              className="h-16 w-16 shrink-0 rounded-xl border border-[rgba(255,255,255,0.3)]"
              aria-hidden="true"
            />
            <div className="flex flex-col items-start gap-2">
              <span className="text-sm font-medium text-[rgba(255,255,255,0.5)]">Coming soon</span>
              <h4 className="text-[32px] leading-[1.1] font-extrabold tracking-[-0.02em] text-white">
                Cai Compliance
              </h4>
              <p className="text-md mt-2 leading-[1.5] text-[rgba(255,255,255,0.7)]">
                An AI compliance agent for small trucking fleets without dedicated safety or compliance staff.
              </p>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  )
}
